module.exports = __webpack_public_path__ + "img/404.43ba1201.png";